import React from 'react';
import { Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const PageHeader = ({ title, subTitle, extra, onBack, children }) => {
  return (
    <div style={{ marginBottom: 24 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 16,
        }}
      >
        <div>
          {onBack && (
            <Typography.Link onClick={onBack} style={{ marginBottom: 8, display: 'inline-block' }}>
              <ArrowLeftOutlined /> 返回
            </Typography.Link>
          )}
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          {subTitle && (
            <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
              {subTitle}
            </Typography.Text>
          )}
        </div>
        {extra && <Space wrap>{extra}</Space>}
      </div>
      {children}
    </div>
  );
};

export default PageHeader;
